import { z } from 'zod'

/**
 * Quem ou o quê escreveu uma linha de histórico (faixa 29, back `3784d500`,
 * `app/routes/shared/event_item.py::OrigemDoEventoItem`). Vem em
 * `ContactEvent`, `UserEvent`, `TgOp`, `TgOpItem`, `ContactTgEvent` e, como
 * `created_by_origem`, em `TransmissionGroupDto`.
 *
 * Os três campos são `str` CRUS no wire. `tipo` hoje é um de
 * `http | apikey | socket | celery | webhook | beat | script | flow`
 * (`app/shared/ator.py::Origem`), mas NÃO é união fechada aqui: origem nova do
 * back não pode derrubar o read — `z.enum` trocaria uma linha estranha por uma
 * página vazia. Quem rotula é `lib/events/origemDoEvento` (mapa com fallback).
 *
 * `id`/`nome` por tipo: `webhook` → `webhook:meta`/`webhook Meta`; `celery` →
 * `celery:<task>`/`<task>` ou `meta:graph`/`Meta (WhatsApp)`; `beat` →
 * `beat:<task>`/`<task>`; `flow` → `_id` do flow/nome; `script` →
 * `script:<nome>`/`<nome>`; `apikey` → `apikey:<db_id>`/`apikey:<nome da key>`;
 * `http`/`socket` → `user_id`/`username`. Nos humanos (`http`/`socket`) o autor
 * continua sendo lido de `by_user_id`/`by_username`, nunca daqui.
 */
export const OrigemDoEventoSchema = z.object({
  tipo: z.string(),
  id: z.string(),
  nome: z.string(),
})

export type OrigemDoEvento = z.infer<typeof OrigemDoEventoSchema>
